import { Component, computed, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzFormModule } from 'ng-zorro-antd/form';
import { TranslatePipe } from '@ngx-translate/core';

/** 创建组织需要回传的值 */
export interface OrganizationCreatePayload {
  code: string;
  name: string;
}

/**
 * 创建组织对话框：填 组织代码 + 组织名称。组织代码即组织主键，用作创建接口的路径参数，
 * 须小写字母开头（校验规则同原创建页）。确定带回一个 OrganizationCreatePayload。
 * 纯内容组件——真正调 `createOrganization` 接口由打开方（账号页）在 afterClose 里做，
 * 与 member.add / string.value.edit 那套对话框同构。
 */
@Component({
  selector: 'organization-create-dialog',
  templateUrl: './organization.create.dialog.component.html',
  styleUrl: './organization.create.dialog.component.less',
  imports: [FormsModule, NzInputModule, NzFormModule, TranslatePipe],
})
export class OrganizationCreateDialogComponent {
  readonly #modal = inject(NzModalRef);

  readonly code = signal('');
  readonly name = signal('');

  /** 两个字段都非空才允许确定（footer 的确认钮依赖这条禁用） */
  readonly valid = computed(() => {
    const code = this.code().trim();
    const name = this.name().trim();
    return name.length > 0 && /^[a-z][a-z0-9-]*$/.test(code);
  });

  cancel(): void {
    this.#modal.destroy(undefined);
  }

  ok(): void {
    if (!this.valid()) {
      return;
    }
    this.#modal.destroy({ code: this.code().trim(), name: this.name().trim() } as OrganizationCreatePayload);
  }

  protected onCodeInput($event: Event): void {
    this.code.set(($event.target as HTMLInputElement).value);
  }

  protected onNameInput($event: Event): void {
    this.name.set(($event.target as HTMLInputElement).value);
  }
}